let timer = undefined;
let duration = (30 + 1) * 60 * 1000;
import { instance } from '@/utils/ajax';
import router from '@/router';

const sessionTimer = {
    refresh() {
        clearTimeout(timer);
        timer = setTimeout(async () => {
            try {
                await instance.get('/api/alive');
            } catch (e) {
                /* eslint-disable no-console */
                console.error('ping alive failed, will be redirected');
            }
        }, duration);
    },
    isStarted() {
        return !!timer;
    },
    destroy() {
        clearTimeout(timer);
        timer = undefined;
    }
};

instance.interceptors.response.use(
    r => {
        if (r.status === 200 && sessionTimer.isStarted()) {
            sessionTimer.refresh();
        }
        return r;
    },
    async e => {
        if (e.response.status === 403) {
            router.push('/logout');
        }
        return Promise.reject(e);
    }
);

export default sessionTimer;
